// Barcodes of a product from api/Product/GetAllByBranch. The API sends the
// first two as `ubc` / `sbc` and every barcode in `productBarcodes`; the
// screens look items up by any of them.

const clean = (v) => `${v ?? ""}`.trim();

export const productBarcodeList = (p) => {
  if (!p) return [];
  if (Array.isArray(p.barcodes)) return p.barcodes;
  const extra = Array.isArray(p.productBarcodes)
    ? p.productBarcodes.map((b) => b?.barcode ?? b?.Barcode)
    : [];
  return [p.barcode, p.ubc, p.sbc, ...extra]
    .map(clean)
    .filter(Boolean)
    .filter((v, i, a) => a.indexOf(v) === i);
};

// the product list as the transaction screens use it: `barcode` is the
// primary barcode, `barcodes` all of them, `cost` the average cost
export const normalizeProduct = (p) => {
  if (!p) return p;
  const barcodes = productBarcodeList(p);
  return {
    ...p,
    barcode: clean(p.barcode) || clean(p.ubc) || barcodes[0] || "",
    barcodes,
    cost: p.cost ?? p.avgCost,
  };
};

// a scanned or typed code is one of the product's barcodes (case ignored)
export const hasBarcode = (p, text) => {
  const t = clean(text).toLowerCase();
  return !!t && productBarcodeList(p).some((b) => b.toLowerCase() === t);
};

// part of a barcode, for the search lists
export const barcodeIncludes = (p, text) => {
  const t = clean(text).toLowerCase();
  return !!t && productBarcodeList(p).some((b) => b.toLowerCase().includes(t));
};

// some other barcode of a product starts with the text and is longer, so a
// scanner may still be typing
export const barcodeCouldGrow = (p, text) => {
  const t = clean(text).toLowerCase();
  return productBarcodeList(p).some((b) => b.length > t.length && b.toLowerCase().startsWith(t));
};
